import { createFileRoute } from '@tanstack/react-router';
import { ProductsPage } from '@/features/admin/Products';
import { ServiceItemsCatalog } from '@/features/admin/ServiceItemsCatalog';

export const Route = createFileRoute('/_app/products')({
  validateSearch: (s: Record<string, unknown>): { view?: 'table' } => ({ view: s.view === 'table' ? 'table' : undefined }),
  component: ProductsRoute,
});

/**
 * Il catalogo articoli MaeDesign è la pagina, su desktop e su telefono: `ServiceItemsCatalog`
 * è responsivo da sé (non serve la coppia Desktop/Mobile) e porta il dettaglio, la creazione,
 * la modifica e l'eliminazione, che prima stavano solo nella vista tabellare.
 *
 * `?view=table` resta e apre la `ResourceListPage` storica: è una superficie che qualcuno può
 * avere nei preferiti, e togliere una strada che funziona non era parte della richiesta.
 */
function ProductsRoute() {
  const { view } = Route.useSearch();
  return view === 'table' ? <ProductsPage /> : <ServiceItemsCatalog />;
}
